import React from 'react';
import {Carousel} from "antd";
import './index.scss';
import ImgAdapt from "../../../../components/img-adapt";

class GoodsCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            pageSize: 0
        };
        this.carouselRef = React.createRef();
        this.smiRef = React.createRef();
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            const {current} = this.smiRef;
            const boxWidth = current.clientWidth;
            const itemEle = current.querySelector('.item');
            if (itemEle) {
                const itemWidth = itemEle.getBoundingClientRect().width + 12;
                this.setState({
                    pageSize: parseInt(boxWidth / itemWidth)
                })
            }

        }
    }

    carouselChange = (index) => {
        this.setState({
            active: index
        })
    };
    changeActive = (index) => {
        const {data = []} = this.props;
        let active = index;
        if (index < 0) {
            active = data.length - 1;
        } else if (index > data.length - 1) {
            index = 0;
        }
        this.setState({
            active: active
        }, () => {
            this.carouselRef.current.goTo(index);
        });
    };

    render() {
        const {data = [], isShowVideoBtn, videoBtnFunc,intl} = this.props;
        const {active, pageSize} = this.state;
        const _style = {
            transform: `translate(${-parseInt(active / pageSize) * 100}%,0)`
        };
        return <div className="goods-detail-carousel">
            <div className={'pos-r'}>
                <Carousel
                    autoplay
                    dots={false}
                    afterChange={this.carouselChange}
                    ref={this.carouselRef}
                >
                    {
                        data.map(item => {
                            return <div key={item.id_} className={'item'}>
                                <ImgAdapt src={item.url_} alt=""/>
                            </div>
                        })
                    }
                </Carousel>
                {
                    isShowVideoBtn &&
                    <div className={'play-video-btn'} onClick={videoBtnFunc} role={'none'}>{intl.messages.BoFangShiPin||'播放视频'}</div>
                }
            </div>

            <div className="carousel-panel">
                <div role='none' className={'btn-prev'} onClick={() => this.changeActive(active - 1)}>&lt;</div>
                <div className={'small-img'} ref={this.smiRef}>
                    <div className="small-img-wrap" style={_style}>
                        {
                            data.map((item, index) => {
                                return <div key={item.id_}
                                            role={'none'}
                                            className={active === index ? 'item active' : 'item'}
                                            onClick={() => this.changeActive(index)}
                                >
                                    <ImgAdapt src={item.url_} alt=""/>
                                </div>
                            })
                        }
                    </div>
                </div>

                <div role={'none'} className={'btn-next'} onClick={() => this.changeActive(active + 1)}>&gt;</div>
            </div>
        </div>
    }
}


export default GoodsCarousel;
